const storageKeys = {
  accessToken: 'guavaAccessToken',
  refreshToken: 'guavaRefreshToken',
  legacyToken: 'guavaToken',
  workspaceId: 'guavaWorkspaceId',

  authCodeChallenge: 'guava-auth-code-challenge',
  authCodeVerifier: 'guava-auth-code-verifier',
  authState: 'guava-auth-state',

  dataGrid: 'guava-datagrid',
  feedbackSelectedTypeId: 'feedback-selected-type-id',

  authProvider: 'guava-auth-provider',
  appDownloadPrompt: 'guava-app-download-prompt',
  fcmToken: 'fcmToken',
  apnsToken: 'apnsToken',
  floatingConversations: 'guava-floating-conversations',
  floatingConversationSize: 'guava-floating-conversation-size',
  bugsnagRandomId: 'bsrid',
};

export const pkceKeys = [
  storageKeys.authCodeChallenge,
  storageKeys.authCodeVerifier,
  storageKeys.authState,
];

export const sessionKeys = [
  storageKeys.accessToken,
  storageKeys.refreshToken,
  storageKeys.legacyToken,
  storageKeys.workspaceId,
  ...pkceKeys,
  storageKeys.dataGrid,
  storageKeys.feedbackSelectedTypeId,
  storageKeys.appDownloadPrompt,
];

export default storageKeys;
